













































































import { Component, Vue } from "vue-property-decorator";
import { Swipe, SwipeItem, List } from "vant";
import request from "@/api/index";
import { INews } from "@/api/types";
import NewsItem from "@/components/newsItem/Index.vue";
import { ColumnInfo } from "@/common/baseConfig";
@Component({
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "news-item": NewsItem,
    "van-list": List
  }
})
export default class Home extends Vue {
  /** 视频新闻列表 */
  newsList: INews[] = [];
  /** 视频 轮播新闻列表 */
  newsSwipeList: INews[] = [];
  /** 来源 */
  origin = "";
  /** 轮播当前index */
  current = 0;

  loading = false;
  finished = false;

  list: number[] = [];

  mounted() {
    if (this.$route.query && this.$route.query.flag === "plan") {
      this.origin = "plan";
    } else if (this.$route.query && this.$route.query.flag === "focus") {
      this.origin = "focus";
    }
  }

  onLoad() {
    setTimeout(() => {
      this.getNewsList();
    }, 300);
  }

  /** 获取新闻列表 */
  async getNewsList() {
    const columnId =
      this.origin === "plan" ? ColumnInfo.融媒策划 : ColumnInfo.外媒聚焦;
    const lastItem = this.newsList[this.newsList.length - 1] || {};
    const result = await request.getInfoList(
      columnId,
      lastItem.id,
      lastItem.sortNo,
      lastItem.onlineTime
    );
    if (!result.code) {
      if (!result.data || result.data.news.length === 0) {
        this.finished = true;
      } else {
        this.loading = false;
        this.newsList = this.newsList.concat(result.data.news);
      }
      this.newsSwipeList = result.data.carousels;
    }
  }

  onChange(index: number) {
    this.current = index;
  }

  /** 融媒策划 轮播控制 */
  moveSwipe(flag: string) {
    const planSwipe = this.$refs.planSwipe as Swipe;
    if (flag === "prev") {
      planSwipe.prev();
    } else {
      planSwipe.next();
    }
  }

  newsClick(data: INews) {
    window.location.href = data.url;
  }
}
